import React from 'react';
import styled from 'styled-components';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

const TableEssayGrades = ({data, className}) => {
  return (
    <div
      className={className}
      style={{ display: 'flex', justifyContent: 'center', paddingTop: '2rem' }}
    >
      <TableContainer className="table-container">
        <Table>
          <TableHead className="tableHeader">
            <TableRow>
              <TableCell className="text-header" align="center">
                Aluno
              </TableCell>
              <TableCell className="text-header" align="center">
                Proficiência
              </TableCell>
              <TableCell className="text-header" align="center">
                Espelho de Prova
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data && data.map((aluno, index) => (
              <TableRow>
                <TableCell
                  className="left-cell data-cell"
                  style={{
                    backgroundColor: index % 2 == 0 ? '#D9D9D9' : '#EDEDED'
                  }}
                >
                  {aluno.NM_ALUNO}
                </TableCell>
                <TableCell
                  align="center"
                  className="data-cell"
                  style={{
                    backgroundColor: index % 2 == 0 ? '#D9D9D9' : '#EDEDED'
                  }}
                >
                  {aluno.NT_ALUNO}
                </TableCell>
                <TableCell
                  align="center"
                  className="data-cell"
                  style={{
                    backgroundColor: index % 2 == 0 ? '#D9D9D9' : '#EDEDED'
                  }}
                >
                  <a href={`https://sesi-correcao.educat.net.br/vista-prova-sesi/${aluno.idn}`} target="_blank">
                    <i className={`fa fa-eye`} style={{ color: 'black' }} />
                  </a>               
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default styled(TableEssayGrades)`
  display: flex;
  align-items: center;
  justify-content: center;

  .table-container {
    width: 70%;
  }

  .tableHeader {
    color: #fff;
    font-size: 1.5rem;
    border-left: 1px solid #000; 
  }

  .text-header {
    border: 1px solid gray;
    color: white;
    background-color: ${props => props.theme.primary};
  }
`;